import { useState } from "react";

const FAQS = [
  {
    num: "01",
    q: "ما الفرق بين المسار والمعسكر والدورة المسجّلة؟",
    a: (
      <>
        <strong className="text-t-primary">المسار:</strong> رحلة ١٠ أسابيع مكثفة
        يومياً تخرج منها بمشروع تخرج حقيقي وشهادة معتمدة — يحتاج التزاماً ٦-٨
        ساعات يومياً.
        <br />
        <br />
        <strong className="text-t-primary">المعسكر:</strong> ٣-٤ أيام مكثفة على
        مهارة تقنية واحدة مع تطبيق فوري وشهادة إتمام.
        <br />
        <br />
        <strong className="text-t-primary">الدورة المسجّلة:</strong> نفس المحتوى
        تشوفه بوقتك دون مواعيد ثابتة — مرونة كاملة.
      </>
    ),
  },
  {
    num: "02",
    q: "هل يوجد شهادة معتمدة؟",
    a: (
      <>
        نعم. جميع البرامج تُصدر شهادة إتمام مصممة لتُضاف مباشرة على{" "}
        <strong className="text-t-primary">LinkedIn</strong> وسيرتك الذاتية. في
        المسارات المكثفة الشهادة مشروطة بإتمام مشروع التخرج وتقديمه أمام لجنة
        تقييم.
      </>
    ),
  },
  {
    num: "03",
    q: "هل يمكن الدفع بالتقسيط؟",
    a: (
      <>
        نعم. الدفع متاح بالتقسيط عبر{" "}
        <strong className="text-t-primary">تمارا</strong> مباشرة من صفحة المنتج
        في متجر آفاق على سلة. لا حاجة لأي إجراء إضافي — الخيار يظهر عند الدفع.
      </>
    ),
  },
  {
    num: "04",
    q: "هل التدريب حضوري أم عن بُعد؟",
    a: (
      <>
        جميع البرامج تُقدَّم{" "}
        <strong className="text-t-primary">عن بُعد أونلاين</strong> — يمكنك
        الانضمام من أي مكان في المملكة أو المنطقة العربية. ساعات التدريب
        الأساسية ٩ صباحاً–٣ مساءً، مع لقاءات إثرائية مسائية أسبوعية مع خبراء
        السوق.
      </>
    ),
  },
  {
    num: "05",
    q: "ما المستوى المطلوب للانضمام؟",
    a: (
      <>
        يختلف حسب البرنامج. بعض المعسكرات تبدأ من الصفر تماماً، والمسارات
        المكثفة مصممة لمستوى متوسط إلى متقدم. المستوى المطلوب مذكور بوضوح في
        صفحة كل برنامج في المتجر.
      </>
    ),
  },
  {
    num: "06",
    q: "هل عندي مشروع تخرج في نهاية المسار؟",
    a: (
      <>
        نعم، وهو <strong className="text-t-primary">متطلب أساسي</strong> للحصول
        على الشهادة في المسارات المكثفة. المشروع حقيقي تُقدّمه أمام لجنة تقييم —
        مو تمرين. يمكنك إضافته مباشرة لملفك المهني وسيرتك الذاتية.
      </>
    ),
  },
  {
    num: "07",
    q: "ما الفرق بين آفاق وبرامج مجانية كتوية وميسك؟",
    a: (
      <>
        آفاق برنامج مدفوع ومتخصص ومحدود المقاعد — هذا مقصود. التركيز على{" "}
        <strong className="text-t-primary">التطبيق العملي الحقيقي</strong>، لا
        على الحضور فقط. تخرج بمشروع وملف مهني وخبرة قابلة للإثبات — لا بشهادة
        حضور. إذا كنت تبحث عن كمية محتوى، البرامج المجانية مناسبة. إذا كنت تبحث
        عن تحوّل حقيقي، آفاق مختلفة.
      </>
    ),
  },
  {
    num: "08",
    q: "كيف أتواصل مع فريق آفاق؟",
    a: (
      <>
        البريد الإلكتروني:{" "}
        <a href="mailto:afaaq@wetaan.com" className="text-mint hover:underline">
          afaaq@wetaan.com
        </a>
        <br />
        ساعات العمل: الأحد–الخميس، ٩ صباحاً–٥ مساءً
        <br />
        حساباتنا على السوشال:{" "}
        <a
          href="https://linktr.ee/AfaaqWetaan"
          target="_blank"
          rel="noopener"
          className="text-mint hover:underline"
        >
          linktr.ee/AfaaqWetaan
        </a>
      </>
    ),
  },
];

function FaqItem({ num, q, a, isOpen, onToggle, delay }) {
  return (
    <div
      className={[
        "rounded-[14px] overflow-hidden border transition-colors duration-300 anim-up",
        isOpen
          ? "border-[rgba(109,211,167,.2)]"
          : "border-[rgba(109,211,167,0.11)] hover:border-[rgba(109,211,167,.22)]",
        "bg-[#0C1F35]",
      ].join(" ")}
      style={{ animationDelay: `${delay}s` }}
    >
      <button
        onClick={onToggle}
        className={[
          "w-full flex items-center justify-between gap-3.5 text-right font-cairo font-bold transition-colors duration-200 cursor-pointer bg-transparent border-0",
          "p-[clamp(16px,1.8vw,22px)_clamp(16px,2vw,24px)]",
          isOpen ? "text-mint" : "text-t-primary hover:text-mint",
        ].join(" ")}
        style={{ fontSize: "clamp(.88rem,1vw,.98rem)", lineHeight: 1.3 }}
      >
        <span>
          <span className="font-mono text-[.52rem] text-t-dim tracking-[.06em] ml-1.5">
            {num} ·
          </span>
          {q}
        </span>

        {/* icon */}
        <span
          className={[
            "w-7 h-7 rounded-full border flex items-center justify-center flex-shrink-0 transition-all duration-300",
            isOpen
              ? "bg-[rgba(109,211,167,.1)] border-mint"
              : "border-[rgba(109,211,167,.2)]",
          ].join(" ")}
        >
          <svg
            className="w-3 h-3 stroke-mint transition-transform duration-300"
            style={{ transform: isOpen ? "rotate(45deg)" : "rotate(0deg)" }}
            viewBox="0 0 24 24"
            fill="none"
            strokeWidth="2.5"
          >
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
        </span>
      </button>

      {/* answer */}
      {isOpen && (
        <div className="px-[clamp(16px,2vw,24px)] pb-[clamp(16px,1.8vw,22px)] border-t border-[rgba(109,211,167,.07)]">
          <p
            className="text-t-sec leading-[1.9] pt-[clamp(12px,1.4vh,16px)]"
            style={{ fontSize: "clamp(.82rem,.88rem,.92rem)" }}
          >
            {a}
          </p>
        </div>
      )}
    </div>
  );
}

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState(0);

  const toggle = (i) => setOpenIdx(openIdx === i ? null : i);

  // split into two columns
  const left = FAQS.filter((_, i) => i % 2 === 0);
  const right = FAQS.filter((_, i) => i % 2 !== 0);

  return (
    <div
      className="relative overflow-hidden px-[clamp(16px,5vw,80px)] pt-[clamp(64px,9vh,110px)]"
      id="faq"
    >
      {/* top divider */}
      <div
        className="absolute top-0 left-[clamp(16px,5vw,80px)] right-[clamp(16px,5vw,80px)] h-px"
        style={{
          background:
            "linear-gradient(90deg,transparent,rgba(109,211,167,0.11) 30%,rgba(109,211,167,0.11) 70%,transparent)",
        }}
      />
      {/* bg glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 70% 50% at 50% 0%,rgba(109,211,167,0.04) 0%,transparent 65%)",
        }}
      />

      {/* ── Header ── */}
      <div
        className="text-center mb-[clamp(40px,5.5vh,64px)] relative z-[2] anim-up"
        style={{ animationDelay: ".05s" }}
      >
        <span className="inline-flex items-center gap-2 font-mono text-[.68rem] tracking-[.2em] uppercase text-mint font-semibold mb-[1.2rem] before:content-['◆'] before:text-[.4rem] before:opacity-40 after:content-['◆'] after:text-[.4rem] after:opacity-40">
          PRE-FLIGHT CHECKLIST · قبل الإقلاع
        </span>
        <h2
          className="font-cairo font-black leading-[1.1] tracking-tight text-t-primary mb-[.6rem]"
          style={{ fontSize: "clamp(1.9rem,3.5vw,3.1rem)" }}
        >
          أسئلة تسأل — <em className="not-italic text-mint">إجابات واضحة</em>
        </h2>
        <p className="text-[.93rem] text-t-sec leading-[1.85] max-w-[440px] mx-auto">
          كل سؤال في ذهنك قبل التسجيل — نجيب عليه هنا بصدق.
        </p>
      </div>

      {/* ── FAQ Grid ── */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-[clamp(10px,1.2vw,14px)] relative z-[2] mb-[clamp(64px,9vh,110px)]">
        {/* left column */}
        <div className="flex flex-col gap-[clamp(10px,1.2vw,14px)]">
          {left.map((item) => {
            const i = FAQS.indexOf(item);
            return (
              <FaqItem
                key={item.num}
                {...item}
                isOpen={openIdx === i}
                onToggle={() => toggle(i)}
                delay={0.08 + i * 0.04}
              />
            );
          })}
        </div>

        {/* right column */}
        <div className="flex flex-col gap-[clamp(10px,1.2vw,14px)]">
          {right.map((item) => {
            const i = FAQS.indexOf(item);
            return (
              <FaqItem
                key={item.num}
                {...item}
                isOpen={openIdx === i}
                onToggle={() => toggle(i)}
                delay={0.08 + i * 0.04}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
